import { render, staticRenderFns } from "./HighlightEditStyle.vue?vue&type=template&id=21886000"
import script from "./HighlightEditStyle.vue?vue&type=script&lang=ts"
export * from "./HighlightEditStyle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21886000')) {
      api.createRecord('21886000', component.options)
    } else {
      api.reload('21886000', component.options)
    }
    module.hot.accept("./HighlightEditStyle.vue?vue&type=template&id=21886000", function () {
      api.rerender('21886000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/HighlightEditStyle.vue"
export default component.exports